import React from "react";
import "../../../styles/open-pages/walkin-form-rating.css";

const MemberRatings = ({ rowData }) => {
  const ratings = rowData?.ratings || {};

  const walkIn = Number(ratings.walk_in_experience) || 0;
  const frontDesk = Number(ratings.front_desk_hospitality) || 0;
  const gymFacility = Number(ratings.gym_facility) || 0;
  const staffInteraction = Number(ratings.staff_interaction) || 0;
  const average = Number(ratings.average_rating) || 0;

  console.log("ratings=> ", ratings);

  return (
    <div className="wtf-ratings-container mt15">
      <div className="wtf-ratings-grid">
        <div className="wtf-rating-item">
          <div className="wtf-rating-label">Walk-in Experience</div>
          <div className="wtf-rating-stars">
            {[...Array(5)].map((_, index) => (
              <span
                key={index}
                className={`wtf-star ${
                  index < walkIn ? "wtf-filled" : "wtf-empty"
                }`}>
                ★
              </span>
            ))}
          </div>
          <div className="wtf-rating-value">{walkIn}/5</div>
        </div>

        <div className="wtf-rating-item">
          <div className="wtf-rating-label">Front Desk Hospitality</div>
          <div className="wtf-rating-stars">
            {[...Array(5)].map((_, index) => (
              <span
                key={index}
                className={`wtf-star ${
                  index < frontDesk ? "wtf-filled" : "wtf-empty"
                }`}>
                ★
              </span>
            ))}
          </div>
          <div className="wtf-rating-value">{frontDesk}/5</div>
        </div>

        <div className="wtf-rating-item">
          <div className="wtf-rating-label">Gym Facility</div>
          <div className="wtf-rating-stars">
            {[...Array(5)].map((_, index) => (
              <span
                key={index}
                className={`wtf-star ${
                  index < gymFacility ? "wtf-filled" : "wtf-empty"
                }`}>
                ★
              </span>
            ))}
          </div>
          <div className="wtf-rating-value">{gymFacility}/5</div>
        </div>

        <div className="wtf-rating-item">
          <div className="wtf-rating-label">Staff Interaction</div>
          <div className="wtf-rating-stars">
            {[...Array(5)].map((_, index) => (
              <span
                key={index}
                className={`wtf-star ${
                  index < staffInteraction ? "wtf-filled" : "wtf-empty"
                }`}>
                ★
              </span>
            ))}
          </div>
          <div className="wtf-rating-value">{staffInteraction}/5</div>
        </div>
      </div>
      <div className="wtf-average-rating">
        <div className="wtf-average-label">Average Rating</div>
        <div className="wtf-average-value">{average}/5</div>
      </div>
    </div>
  );
};

export default MemberRatings;
